import { useCallback, useMemo, useState } from "react";
import api from "../../../../utils/api";
import { Checkin } from "../../../../types";
import useLoading from "../../../../hooks/useLoading";
import { useErrorSuccess } from "../../../../hooks/useErrorSuccess";

export type ResponseMembrosCheckin = {
  listAll: Checkin[] | []
  reset: VoidFunction
  nextPagina: VoidFunction
  getWithParams: (params: any) => void
  pagina: number,
  getSearchNome: (e: any) => void
  nome: string | undefined
  isLoading: boolean
}

const GetMembros = (): ResponseMembrosCheckin => {

  const { isLoading, startLoading, stopLoading } = useLoading();
  const { setMensagemError } = useErrorSuccess();

  const [listCheckinMembros, setListCheckinMembros] = useState<Checkin[]>([]);
  const [pagina, setPagina] = useState<number>(0);
  const [nome, setNome] = useState<string>();


  const getSearchNome = (event: any) => setNome(event?.target?.value);

  const nextPagina = useCallback(() => {
    setPagina((pagina) => pagina + 1)
  }, [pagina]);

  const reset = async () => {
    await getList()
  }

  const getWithParams = (params: any) => {
    startLoading();
    api.get<Checkin[]>('view/registro/checkin', { params: { ...params } })
      .then(
        (sucesso) => {
          setListCheckinMembros(sucesso?.data);
          setPagina(1);
        }
      )
      .catch(
        (error) => {
          setMensagemError(JSON.stringify(error?.response?.data, null, 2));
        }
      ).finally(() => {
        stopLoading();
      })
  }


  const getList = useCallback(async () => {
    api.get<Checkin[]>('view/registro/checkin')
      .then(
        (sucesso) => {
          setListCheckinMembros(sucesso?.data);
          setPagina(1);
        }
      )
      .catch(
        (error) => {
          setMensagemError(JSON.stringify(error?.response?.data, null, 2));
        }
      )
  }, []);

  useMemo(() => {
    getList()
  }, [])


  return {
    listAll: listCheckinMembros,
    reset,
    nextPagina,
    pagina,
    getWithParams,
    nome,
    getSearchNome,
    isLoading
  };
}

export default GetMembros;
